import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminPeople(q, cursor) {
    return useQuery({
        queryKey: adminKeys.peopleList(q, cursor),
        queryFn: () => adminApi.browsePeople(q, cursor),
    });
}
